<sn-file-upload
  [allowPreview]="to.allowPreview"
  [multiple]="to.multiple"
  [allowedContentTypes]="to.allowedContentTypes"
  [maxFileSize]="to.maxFileSize"
  [accept]="to.accept"
  [formControl]="formControl"
>
</sn-file-upload>
